module.exports = __webpack_public_path__ + "img/icon-settle.8f36f4fb.png";